'use client';

import { useLocale } from 'next-intl';
import type { Locale } from '~/i18n/i18n-config';
import { api } from '~/libs/api';
type Source = 'booking_email_capture' | 'concierge_email_capture' | 'contact_email_capture';
type SubmitArgs = {
  email: string;
  marketingOptOut?: boolean | null;
  privacyPolicyAccepted: boolean;
  firstName?: string;
  lastName?: string;
  journeyUrl?: string;
  itineraryId?: string;
  newsletterSignup?: boolean;
};
export function useMarketingOptOut(source: Source, onError?: (error: unknown) => void) {
  const mutation = api.automation.submitMarketingOptOut.useMutation();
  const locale = useLocale() as Locale;
  return async ({
    email,
    marketingOptOut,
    privacyPolicyAccepted,
    firstName,
    lastName,
    journeyUrl,
    itineraryId,
    newsletterSignup
  }: SubmitArgs): Promise<void> => {
    try {
      await mutation.mutateAsync({
        email,
        marketing_optin: !(marketingOptOut ?? false),
        source,
        privacy_policy_accepted: privacyPolicyAccepted,
        first_name: firstName ?? '',
        last_name: lastName ?? '',
        ...(journeyUrl ? {
          journey_url: journeyUrl
        } : {}),
        ...(itineraryId ? {
          itinerary_id: itineraryId
        } : {}),
        newsletter_signup: newsletterSignup,
        locale
      });
    } catch (error) {
      onError?.(error);
    }
  };
}